import { Button } from "@/shared/components/ui/button";
import { Trash } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import t from "@/lang/lang";
import { useEffect, useState } from "react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useRltDocumentationDeleteItemMutation } from "@/services/backend/rlt/work-orders/api/documentation-api";
import { useErrValidationFailedContext } from "@/shared/lib/errors/err-validation-failed-context";

export function DeleteItemButton(props: {
  documentationId: string;
  itemId: string;
  disabled?: boolean;
}) {
  const { documentationId, itemId, disabled = false } = props;
  const [open, setOpen] = useState(false);
  const [deleteItem, { isLoading, error, isSuccess, reset }] =
    useRltDocumentationDeleteItemMutation();

  const onClick = () => {
    if (isLoading) {
      return;
    }
    deleteItem({
      id: documentationId,
      itemId,
    });
  };

  const { resetField } = useErrValidationFailedContext();

  useEffect(() => {
    if (isSuccess) {
      // The work order's readiness check reports an insufficient
      // documentation; the user changed it.
      resetField("documentation");
      reset();
      setOpen(false);
    }
  }, [isSuccess, setOpen, reset, resetField]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive" disabled={disabled}>
          <Trash className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Wirklich löschen?")}</DialogTitle>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onClick} disabled={isLoading}>
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
